import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "eb1d6ba337b0a27a6d274167f56105f6109a16a8",
});
